import { DASHBOARD_LINK } from '@components/Router/constants'
import { managerActions } from '@store/reducers/manager/actions'
import { metaActions } from '@store/reducers/manager/meta/index'
import { push } from 'redux-first-history'

import API from '@/api'
import * as ActionTypes from '../actions'
import { UPDATE_UI } from '../actions'
import { closeModal } from './ui'

export const deleteMember = (payload) => (dispatch, getState) => {
  const { auth } = getState()
  API.Members.delete(payload)
    .then(() => {
      dispatch(metaActions.deleteMember(payload.id))

      if (auth.id === payload.id) {
        dispatch(closeModal())
        dispatch(push(DASHBOARD_LINK))
        dispatch(managerActions.resetProject())
      }
    })
    .catch((e) => console.error('Problem with deleting member from project', e))
}

export const deleteInvitation = (payload) => (dispatch) => {
  API.Invitation.delete(payload)

  dispatch(metaActions.deleteMemberInvitation(payload))
}

export const updateProjectPreview = (projectId) => async (dispatch) => {
  try {
    dispatch({
      type: ActionTypes.UPDATE_PROJECT_PREVIEW,
      payload: {
        id: projectId,
        isLoading: true,
      },
    })

    const result = await API.Projects.updatePreview(projectId)

    dispatch({
      type: ActionTypes.UPDATE_PROJECT_PREVIEW,
      payload: {
        id: projectId,
        thumbnail: result.thumbnail,
        isLoading: false,
      },
    })
  } catch (e) {
    dispatch({
      type: UPDATE_UI,
      payload: { notification: 'TEAM_REQUEST_ERROR' },
    })
  }
}
